// 域名转换逻辑
// u1www.infiniumbank.com => u1static.infiniumbank.com
// u2www.infiniumbank.com => u2static.infiniumbank.com
// u3www.infiniumbank.com => u3static.infiniumbank.com
// www.infiniumbank.com => static.infiniumbank.com
// www.fusionbank.com => static.fusionbank.com
// m.fusionbank.com => static.fusionbank.com

// __webpack_public_path__ 变量是 webpack 的内置变量, 会影响资源的载入地址

__webpack_public_path__ = (function(global) {
  var host = global.location && global.location.host;
  if (!host) return __webpack_public_path__;

  // 因为特殊原因，我们之前的静态资源，有一部分是使用一个独立模块发布的
  // 比如vb-static-resource、vb-app-resource
  // 对应的生产环境的目录是：
  // vb-static-resource ===> static.fusionbank.com/resource
  // vb-app-resource ===> static.fusionbank.com/appresource
  // 如果我们希望使用一些公共的CDN资源，我们可以在业务代码里面使用
  // window._staticDomain来获取当前环境的静态资源域名信息
  var staticDomain = host
    .replace(/^u1www\.infiniumbank/, 'u1static.infiniumbank')
    .replace(/^u2www\.infiniumbank/, 'u2static.infiniumbank')
    .replace(/^u3www\.infiniumbank/, 'u3static.infiniumbank')
    .replace(/^www\.infiniumbank/, 'static.infiniumbank')
    .replace(/^www\.fusionbank/, 'static.fusionbank')
    .replace(/^m\.infiniumbank/, 'static.infiniumbank')
    .replace(/^m\.fusionbank/, 'static.fusionbank');
  global._staticDomain = staticDomain;
  // 但，使用webpack编译出来的项目，我们目前是将静态资源跟业务js发布的
  // 之前，业务代码模块，是会发布static、www两个域名下的所有服务器
  // 后来，运维团队修改了这里的规则，业务代码模块，只能发布到www域名对应的服务器
  // 从而造成结果就是：我们业务场景使用到的静态资源，只能使用www域名
  return '//' + host + __webpack_public_path__;
})(window);
